import {RRule,RRuleSet} from "./rrule/rrule.js";
//import {RRule,RRuleSet} from "./rrule/rrule271.js";

import * as DateUtils from "../lib/DateUtils.ts";

/**
 * @param {Date} date
 * @param {hour} number
 * 
 */
function setHours(date,hour){
  var result = new Date(date.getFullYear(),date.getMonth(),date.getDate(),hour,date.getMinutes(),date.getSeconds());
  return result
}


/**
 * IHasRecurrency{
 *  startDate
 *  endDate
 *  allDay
 *  recurrencyDescriptor
 * }
 */

class IHasRecurrencyHelper{
  static getRange(recurrencyTypeEnum, date){
    switch(recurrencyTypeEnum){
      case 'YEARLY':
        return DateUtils.getYearRange(date);
      case 'MONTHLY':
        return DateUtils.getMonthRange(date);
      case 'BIWEEKLY':
        return DateUtils.getWeekRange(date,undefined,2);
      case 'WEEKLY':
        return DateUtils.getWeekRange(date);
      case 'DAILY':
        return DateUtils.getDayRange(date);
      default:
        return DateUtils.getFullRange();
    }
  }
  static getClosest(iHasRecurrency,date){
    var occurrences = this.listInterval(iHasRecurrency,{start:iHasRecurrency.start,end:date},2);
    occurrences.sort((a,b)=>Math.abs(a.start-date)-Math.abs(b.start-date))
    return occurrences[0];
  }
  
  static listInterval(iHasRecurrency, range, extra=0){
    //case of task without duedate
    if(!iHasRecurrency.startDate){
      return [];
    }
    if(extra===0){
      if(iHasRecurrency.startDate>range.end){
        return [];
      }
      //end before range
      if(iHasRecurrency.endDate<range.start && !iHasRecurrency.recurrencyDescriptor.rrule){
        return [];
      }
    }
    var 
      result = [],
      recurrencyDescriptor = iHasRecurrency.recurrencyDescriptor,
      proto = function(){};
    if(recurrencyDescriptor.rrule){
      proto.prototype = iHasRecurrency;

      var 
        date = iHasRecurrency.startDate,
        hours = iHasRecurrency.startDate.getHours(),
        duration = iHasRecurrency.endDate?iHasRecurrency.endDate-iHasRecurrency.startDate:0,
        durationInDays = Math.round(duration/86400000),
        exdate = recurrencyDescriptor.exdate?recurrencyDescriptor.exdate.map(function(d){return d.getTime()}):[],  //seams that indexOf for Date does not work, so we use the timeinmilis
        recurrencyDeletedOccurence = recurrencyDescriptor.recurrencyDeletedOccurence,
        options = RRule.parseString(recurrencyDescriptor.rrule),
        ruleSet = new RRuleSet(),
        LIMIT = 20000;

      
      if(iHasRecurrency.allDay){
        //l'heure d'été à aukland met la zone alors on s'assure qu'on sera bien le bon jour avec cette bidouille
        var delta = Math.round(date.getTimezoneOffset()/120);
        options.dtstart = setHours(date,12-delta);
        if(options.until){
          options.until = new Date(options.until.toISOString().substring(0,10)+'T23:59:59')
        }
      }else{
        options.dtstart = date;
      }
      
      ruleSet.rrule(new RRule(options));
      
      //we do not use exDate because we need the index in the eventId rebuild
      
      ruleSet.all(function(date,idx){
        if(LIMIT--<=0){
          console.log("recurrency infiniteloop error with ",iHasRecurrency)
          import("../ApiServer.js").then(ApiServer=>{
            ApiServer.default.webjslog("recurrency infiniteloop error with "+iHasRecurrency.metaId)
          });
          return false;
        }
        
        date = setHours(date,hours);
        
        
        
        if(date>=range.end) {
          //we are after the range we stop the iteration
          if(extra<=0){
            return false;
          }else{
            extra--;
          }
        }
        let endDate = new Date(date.getTime()+duration);
        if(iHasRecurrency.allDay){
          endDate = new Date(date.getFullYear(),date.getMonth(),date.getDate()+durationInDays-1,23,59,59) 
        }
        
        if(endDate<range.start){
          return true;
        }
        //for google | outlook we do not have
        if(exdate.indexOf(date.getTime())!==-1){
          return true;
        }
        if(recurrencyDeletedOccurence.indexOf(idx)!==-1){
          return true;
        }
        if(endDate>range.start){
          var instance = new proto();
          instance.metaId = instance.metaId+"_"+idx;
          instance.start = date;
          instance.end = endDate;
          instance.occurence = idx;
          
          result.push(instance);
        }
        return true;
      });
    }else{
      result.push(iHasRecurrency)
    }      
    return result;
  }
}


export default IHasRecurrencyHelper;